/**
 * KAN-951: list of help sections (links to /help/:slug) with durations.
 */
import { Link } from 'react-router-dom';
import { PlayCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { formatDuration, type HelpItem } from '@/tutorials/content';
import { helpPath } from './useHelpPlayer';

interface HelpSectionListProps {
  items: HelpItem[];
  currentSlug: string | undefined;
}

export function HelpSectionList({ items, currentSlug }: HelpSectionListProps) {
  return (
    <nav aria-label="Разделы справки">
      {items.length === 0 ? (
        <p className="px-3 py-6 text-center text-sm text-gray-500">Ничего не найдено</p>
      ) : (
        <ul className="space-y-1">
          {items.map((item) => {
            const active = item.slug === currentSlug;
            return (
              <li key={item.slug}>
                <Link
                  to={helpPath(item)}
                  aria-current={active ? 'page' : undefined}
                  className={cn(
                    'flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors',
                    active
                      ? 'bg-blue-50 font-medium text-blue-700'
                      : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                  )}
                >
                  <PlayCircle
                    aria-hidden="true"
                    className={cn('h-4 w-4 shrink-0', active ? 'text-blue-600' : 'text-gray-400')}
                  />
                  <span className="min-w-0 flex-1 truncate">{item.title}</span>
                  <span className="shrink-0 tabular-nums text-xs text-gray-500">
                    {formatDuration(item.duration)}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </nav>
  );
}
